import type { PressableProps } from '../pressable';

import type { IconByType } from './constants';

export type ServiceModeLocationType = keyof typeof IconByType;

export type ServiceModeLocationProps = Omit<PressableProps, 'children'> & {
  loading: boolean;
  type: ServiceModeLocationType;
  storeText?: string;
  serviceModeSubtitle?: string;
};
